import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Button, Input, Selector } from "../Elements";
import Modal from "../Modal";
import { getSendOptionById, sendOptions, sendTypeIds } from "../../../constants/options/sendOptions";
import { controlPaymentLinkPackages } from '../../../common/helpers/packagesHelper';
import { toast } from "react-toastify";
import commonNetwork from "../../../common/api/commonNetwork";
import PaymentLinkResultModal, { PaymentLinkResultModalRefProps } from "../PaymentLinkResultModal";
import { isValidEmailAddress, isValidPhoneNumber } from "../../../common/helpers/globalHelpers";
import { SabeeappBookingListProps } from "../../../common/types";
import RadioButtons from "../Elements/RadioButtons";

type PaymentTypes = "openLink" | "sendLink"
type FormProps = {
    amount: string,
    paymentType: PaymentTypes,
    sendtype: number,
    phone: string,
    email: string,
    linkDesc: string,
}
type Props = {

}
export type CreatePaymentLinkModalRefProps = {
    openModal: (sabeeAppItem: SabeeappBookingListProps) => void
}

const CreatePaymentLinkModal = React.forwardRef<CreatePaymentLinkModalRefProps, Props>((props: Props, ref) => {
    const linResultModalRef = useRef<PaymentLinkResultModalRefProps>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [statusModalVisible, setStatusModalVisible] = React.useState(false);
    const [sabeeAppBookItem, setSabeeAppBookItem] = useState<SabeeappBookingListProps>();
    const [fields, setFields] = useState<FormProps>({
        amount: "",
        paymentType: "openLink",
        sendtype: 3,
        phone: "",
        email: "",
        linkDesc: "",
    });

    const [createLoading, setCreateLoading] = useState(false);

    useImperativeHandle(ref, () => ({

        openModal(sabeeAppItem) {
            onOpenModalClick(sabeeAppItem);
        }

    }));
    const onOpenModalClick = (sabeeAppItem: SabeeappBookingListProps) => {
        const paymentAmount = (sabeeAppItem.rooom_price - (sabeeAppItem.paid || 0)).toFixed(2);
        const customerName = sabeeAppItem.customer.first_name + " " + sabeeAppItem.customer.last_name;
        const linkDesc = sabeeAppItem.reservation_code + " - " + customerName + " Ödemesi";
        setSabeeAppBookItem(sabeeAppItem);
        setFields({
            amount: paymentAmount,
            email: sabeeAppItem.customer.email,
            linkDesc: linkDesc,
            paymentType: "openLink",
            phone: sabeeAppItem.customer.phone_number,
            sendtype: 3
        });
        setIsModalVisible(true);

    }

    const onPostClick = () => {

        if ((!fields.amount || parseInt(fields.amount) <= 0)) {
            toast.error("Lütfen geçerli bir tutar giriniz.");
            return;
        }
        if (fields.paymentType == "sendLink") {
            const sendTypeId = fields.sendtype;


            if ((sendTypeId == sendTypeIds.emailAndSms || sendTypeId == sendTypeIds.email) && (fields.email.length == 0 || isValidEmail()?.length > 0)) {
                toast.error("Lütfen geçerli bir E-Mail Adresi giriniz.");
                return;
            }
            if ((sendTypeId == sendTypeIds.emailAndSms || sendTypeId == sendTypeIds.sms || sendTypeId == sendTypeIds.whatsapp)
                && (fields.phone.length == 0 || isValidPhone()?.length > 0)) {
                toast.error("Lütfen geçerli bir Telefon Numarası giriniz.");
                return;
            }
        }
        onPost();
    }
    const onPost = async () => {



        setCreateLoading(true);
        var smsCount = 0, emailCount = 0, whatsappCount = 0;
        if (fields.sendtype == sendTypeIds.sms) {
            smsCount++;
        } else if (fields.sendtype == sendTypeIds.email) {
            emailCount++;
        } else if (fields.sendtype == sendTypeIds.whatsapp) {
            whatsappCount++;
        } else {
            emailCount++;
            smsCount++;
        }

        const packageResult = await controlPaymentLinkPackages(smsCount, emailCount, whatsappCount);
        if (packageResult.serviceError != true) {

            const { isMailOverflow, isSmsOverflow, isWhatsappOverflow } = packageResult;
            if (isMailOverflow || isSmsOverflow || isWhatsappOverflow) {

                toast.error("SMS/Email/Whatsapp paketiniz tükenmiştir. Ödeme linki oluşturmak için SMS/E-mail/Whatsapp paketi satın almanız gerekmektedir.");
            } else {

                postPaymentLinksAfterControl();
            }


        } else {
            toast.error(packageResult.errorMessage);
        }
    }

    const postPaymentLinksAfterControl = async () => {

        const params = {
            TimeInterval: 4,
            LinkDesc: fields.linkDesc,
            SendTpyeId: fields.paymentType == "openLink" ? sendTypeIds.link : fields.sendtype,
            PaymentAmount: fields.amount,
            Email: fields.email,
            Phone: fields.phone,
            BookItem: sabeeAppBookItem
        }

        const response = await commonNetwork.post("/sabeeapp/create-link", params);

        const { isSuccess, data, errorMessage } = response;
        setCreateLoading(false);
        if (isSuccess) {
          

            setIsModalVisible(false);

            if (fields.paymentType == "openLink") {
                window.open(data.link, "_blank");
                return;
            } else {
                const errorList: any = [], successList = [];
                if ((!data.smsstatus || !data.mailstatus || !data.whatsappstatus)) {
                    errorList.push({
                        ...data,
                    });
                } else {
                    successList.push({
                        ...data
                    });
                }

                linResultModalRef.current?.showMessage(errorList, successList, false);




                setStatusModalVisible(true);
            }

        } else {
            toast.error(errorMessage);
        }

    }

    const onChangeField = (event: any) => {


        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }

    const onChangeSelectField = (name: string, value: string) => {


        setFields({
            ...fields,
            [name]: value
        });
    }
    const isValidPhone = () => {


        if (fields.phone) {
            var phoneStatus = isValidPhoneNumber(fields.phone);
            if (phoneStatus) {
                return "";
            } else {
                if (fields.sendtype == 1 || fields.sendtype == 3) {
                    return "Lütfen telefon numarasını doğru formatta giriniz.";
                }

            }
        } else {
            return "";
        }
        return "";
    }

    const isValidEmail = () => {
        if (fields.email) {
            var mailStatus = isValidEmailAddress(fields.email);
            if (mailStatus) {
                return "";
            } else {
                if (fields.sendtype == 2 || fields.sendtype == 3) {
                    return "Lütfen Email adresini doğru formatta giriniz.";
                }

            }
        } else {
            return "";
        }
        return "";
    }

    return (
        <>
            <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible}></PaymentLinkResultModal>
            <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
                <div>
                    <div className="sm:flex sm:items-start mv">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                            <h3 className="text-xl leading-6 font-medium text-gray-900">
                                Ödeme Al

                            </h3>
                            <div className="flex w-100">
                                <div className="flex-auto w-50 mb-6">

                                    <div className="mt-4">
                                        <Input
                                            name={`amount`}
                                            value={fields.amount}
                                            currencyformat={true}
                                            currencyicon
                                            currencySymbol={sabeeAppBookItem?.currency}
                                            type="text"
                                            className="w-[100%]"
                                            label="Tutar"
                                            onChange={onChangeField}
                                            required
                                            error={isValidEmail()}
                                            isTRCurrencyDisplay={true}
                                        />
                                    </div>
                                    <div className="flex  pr-6 text-contrast-70  mt-6 ">
                                        <span>
                                            Ödeme Tipi
                                        </span>
                                        <div className="items-center text-center ml-4">
                                            <RadioButtons
                                                items={[
                                                    { label: "Anlık Ödeme Al", value: "openLink" },
                                                    { label: "Ödeme Linki Gönder", value: "sendLink" },
                                                ]}
                                                onValueChange={(event: any) => {
                                                    setFields({
                                                        ...fields,
                                                        paymentType: event.target.value
                                                    });
                                                }}
                                                checked={fields.paymentType}
                                            />
                                        </div>
                                    </div>
                                    {fields.paymentType == "sendLink" && (
                                        <>
                                            <div className="mt-4">
                                                <Selector
                                                    options={sendOptions.filter(option => option.value !== 0)}
                                                    name={`sendtype`}
                                                    defaultValue={getSendOptionById(fields.sendtype || 3)}
                                                    className="w-[100%] text-left"
                                                    label="Gönderim Şekli"
                                                    menuPortalTarget={document.body}
                                                    onChange={({ value }: any) => onChangeSelectField("sendtype", value)}
                                                    required 
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <Input
                                                    name={`linkDesc`}
                                                    value={fields.linkDesc}
                                                    className="w-[100%]"
                                                    label="Link Açıklaması"
                                                    onChange={onChangeField}
                                                    required
                                                    type="text"
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <Input
                                                    name={`email`}
                                                    value={fields.email}
                                                    type="text"
                                                    className="w-[100%]"
                                                    label="E-Mail Adresi"
                                                    onChange={onChangeField}
                                                    required={fields.sendtype == sendTypeIds.emailAndSms ||fields.sendtype == sendTypeIds.email}
                                                    error={isValidEmail()}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <Input
                                                    name={`phone`}
                                                    value={fields.phone}
                                                    type="text"
                                                    className="w-[100%]"
                                                    label="Telefon Numarası"
                                                    onChange={onChangeField}
                                                    required={fields.sendtype == sendTypeIds.emailAndSms ||fields.sendtype == sendTypeIds.sms ||fields.sendtype == sendTypeIds.whatsapp}
                                                    error={isValidPhone()}
                                                />
                                            </div>

                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                            color="gray"
                            hover="gray"
                            size="xs"
                            callback={() => setIsModalVisible(false)}
                        >
                            İptal
                        </Button>
                        <Button
                            color="primary"
                            hover="primary"
                            size="xs"
                            loading={createLoading}
                            disabled={createLoading}
                            callback={onPostClick}
                        >
                            Gönder
                        </Button>
                    </div>
                </div>
            </Modal>

        </>
    );
})

export default CreatePaymentLinkModal;